/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Functional_TrainingInputs */

const en_service_type_functional_training = /** @type {(inputs: Service_Type_Functional_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Functional training`)
};

const pl_service_type_functional_training = /** @type {(inputs: Service_Type_Functional_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening funkcjonalny`)
};

/**
* | output |
* | --- |
* | "Functional training" |
*
* @param {Service_Type_Functional_TrainingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_functional_training = /** @type {((inputs?: Service_Type_Functional_TrainingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Functional_TrainingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_functional_training(inputs)
	return en_service_type_functional_training(inputs)
});